import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotification } from "../redux/notificationSlice";
import { isNotificationAllowed } from "./notificationUtils";
import { getNotificationPeriodHours } from "./notifications/notificationPeriodUtils";
import { hasMonitoringModule } from "./mobileModuleUtils";
import { fetchMonitoringGroupedContainers } from "./collection/monitoringListUtils";

export const useMobileHomeMetrics = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notification.data);
  const notificationStatus = useSelector((state) => state.notification.status);
  const user = useMemo(
    () => JSON.parse(localStorage.getItem("user")) || null,
    [],
  );
  const monitoringEnabled = hasMonitoringModule();
  const periodHours = getNotificationPeriodHours();

  const [criticalFillingContainersCount, setCriticalFillingContainersCount] =
    useState(0);
  const [containersLoading, setContainersLoading] = useState(false);

  const unreadNotificationsCount = useMemo(() => {
    return notifications.filter(
      (notification) =>
        isNotificationAllowed(notification, user) && !notification.read,
    ).length;
  }, [notifications, user]);

  useEffect(() => {
    if (notificationStatus !== "idle") {
      return;
    }
    dispatch(fetchNotification(periodHours));
  }, [dispatch, periodHours, notificationStatus]);

  useEffect(() => {
    if (!monitoringEnabled) {
      setCriticalFillingContainersCount(0);
      return;
    }

    let isMounted = true;

    const loadContainersCount = async () => {
      setContainersLoading(true);
      try {
        const { criticalFillingCount } =
          await fetchMonitoringGroupedContainers();
        if (isMounted) {
          setCriticalFillingContainersCount(criticalFillingCount);
        }
      } finally {
        if (isMounted) {
          setContainersLoading(false);
        }
      }
    };

    void loadContainersCount();

    return () => {
      isMounted = false;
    };
  }, [monitoringEnabled]);

  return {
    unreadNotificationsCount,
    criticalFillingContainersCount,
    containersLoading,
    monitoringEnabled,
    notificationsLoading: notificationStatus === "loading",
  };
};
